import { EnvironmentSecrets } from './types/secrets';

export const devSecrets: EnvironmentSecrets = {
  testFirebaseUserUserName: '',
  testFirebaseUserPassword: '',
  domain: '',
  clientId: '',
  loginUrl: '',
  cloudFunctionUrl: '',
};
